import React from "react";

const Experience = () => {
  return (
    <div id="experience" className="content-holder">
      <h2>Experience</h2>
      <div className="content-holder-experience">
        <div className="content-holder-experience__right-firm-year">
          <h3>S-Tier Development </h3>
          <p>2025 – Contract Collaboration </p>
        </div>
        <h4>WordPress Developer</h4>
        <p>
          Collaborated with the S-Tier Development team on the development and
          maintenance of WordPress websites for various clients. Projects were
          built using an internal framework based on Gutenberg blocks and ACF,
          using a development workflow based on WPGulp and SCSS. I was
          responsible for implementing frontend solutions, customizing blocks
          according to design requirements, and improving the functionality of
          existing projects.
        </p>
        <div className="content-holder-experience__right-tech">
          <span>HTML</span>
          <span>SCSS</span>
          <span>JavaScript</span>
          <span>PHP</span>
          <span>Wordpress</span>
          <span>WP Gulp</span>
          <span>Gutemberg bloks</span>
          <span>CSS Animation</span>
          <span>JavaScript Animation</span>
          <span>Design</span>
        </div>
      </div>
      <div className="content-holder-experience">
        <div className="content-holder-experience__right-firm-year">
          <h3>JV Dev Center </h3>
          <p>2024 – Contract Collaboration </p>
        </div>
        <h4>WordPress Developer</h4>
        <p>
          Collaborate with the JV Dev Center team to manage all aspects of
          website development, including design, frontend, backend,
          responsiveness, and deployment. Primarily work with WordPress themes
          and Elementor to create tailored solutions.
        </p>
        <div className="content-holder-experience__right-tech">
          <span>HTML</span>
          <span>CSS</span>
          <span>JavaScript</span>
          <span>PHP</span>
          <span>Wordpress</span>
          <span>Elementor</span>
          <span>CSS Animation</span>
          <span>JavaScript Animation</span>
          <span>Design</span>
        </div>
      </div>
      <div className="content-holder-experience">
        <div className="content-holder-experience__right-firm-year">
          <h3>Bureau TwentyTwo</h3>
          <p>2021 - 2024</p>
        </div>
        <h4>Web Developer</h4>
        <p>
          As a web developer, my main responsibility was working on the
          development of frontend technologies like HTML, CSS, and JavaScript.
          Over the past year, I frequently transitioned into backend
          development, using PHP, which allowed me to gain broader experience in
          creating complete web solutions. I developed websites using custom
          themes, writing the entire code from scratch. In close collaboration
          with designers, I created pixel-perfect websites, ensuring
          responsiveness and SEO optimization, delivering both technically and
          visually optimized projects.
        </p>
        <div className="content-holder-experience__right-tech">
          <span>HTML</span>
          <span>CSS</span>
          <span>JavaScript</span>
          <span>PHP</span>
          <span>jQuery</span>
          <span>Git</span>
          <span>Deploy</span>
          <span>SEO</span>
          <span>WordPress</span>
          <span>CSS Animation</span>
          <span>JavaScript Animation</span>
        </div>
      </div>
    </div>
  );
};

export default Experience;
